/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import client from '@/shared/api/axios-client'
import type { GetCitiesQueryResponse, GetCities400 } from '../entities/GetCities'
import type { RequestConfig, ResponseErrorConfig } from '@/shared/api/axios-client'
import type { QueryKey, QueryClient, QueryObserverOptions, UseQueryResult } from '@tanstack/react-query'
import { getCities } from '../api/getCities'
import { queryOptions, useQuery } from '@tanstack/react-query'

export const getCitiesQueryKey = () => [{ url: '/cities' }] as const

export type GetCitiesQueryKey = ReturnType<typeof getCitiesQueryKey>

export function getCitiesQueryOptions(config: Partial<RequestConfig> & { client?: typeof client } = {}) {
  const queryKey = getCitiesQueryKey()
  return queryOptions<GetCitiesQueryResponse, ResponseErrorConfig<GetCities400>, GetCitiesQueryResponse, typeof queryKey>({
    queryKey,
    queryFn: async ({ signal }) => {
      config.signal = signal
      return getCities(config)
    },
  })
}

/**
 * @description Get company cities
 * @summary Get company cities
 * {@link /cities}
 */
export function useGetCities<TData = GetCitiesQueryResponse, TQueryData = GetCitiesQueryResponse, TQueryKey extends QueryKey = GetCitiesQueryKey>(
  options: {
    query?: Partial<QueryObserverOptions<GetCitiesQueryResponse, ResponseErrorConfig<GetCities400>, TData, TQueryData, TQueryKey>> & { client?: QueryClient }
    client?: Partial<RequestConfig> & { client?: typeof client }
  } = {},
) {
  const { query: { client: queryClient, ...queryOptions } = {}, client: config = {} } = options ?? {}
  const queryKey = queryOptions?.queryKey ?? getCitiesQueryKey()

  const query = useQuery(
    {
      ...(getCitiesQueryOptions(config) as unknown as QueryObserverOptions),
      queryKey,
      ...(queryOptions as unknown as Omit<QueryObserverOptions, 'queryKey'>),
    },
    queryClient,
  ) as UseQueryResult<TData, ResponseErrorConfig<GetCities400>> & { queryKey: TQueryKey }

  query.queryKey = queryKey as TQueryKey

  return query
}